import React, { useState } from 'react';
import bowser from 'yola-bowser';
import IconButton from '../../icon-button';
import Heading from '../../heading';
import Box from '../../box';
import InfoWithPopover from '../../info-with-popover';
const isTouchDevice = bowser.mobile || bowser.tablet;

const ToggleSectionLayout = ({
  children = undefined,
  title,
  popoverProps = undefined,
  onReload = undefined,
  toggleSlot,
  isContentVisible,
}) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(isTouchDevice);

  const handlers = {
    onMouseEnter: () => {
      setIsPopoverVisible(true);
    },
    onMouseLeave: () => {
      setIsPopoverVisible(false);
    },
  };

  return (
    <div className="ws-ui-toggle-section" {...(!isTouchDevice && { ...handlers })}>
      <div className="ws-ui-toggle-section__header">
        <div className="ws-ui-toggle-section__header-content">
          <Heading type="heading-6" singleLine>
            {title}
          </Heading>
          {popoverProps && isPopoverVisible && (
            <InfoWithPopover {...popoverProps} {...(isTouchDevice && { mode: 'popover' })} />
          )}
        </div>
        <div className="ws-ui-toggle-section__header-actions">
          {onReload && <IconButton glyph="reset" onClick={onReload} size="small" transparent />}
          {toggleSlot}
        </div>
      </div>
      {!!children && isContentVisible && <Box marginTop="spacing-2-xs">{children}</Box>}
    </div>
  );
};

export default ToggleSectionLayout;
